<script>
import {
    layoutMethods,
    layoutComputed
} from "@/state/helpers";
import Vertical from "./vertical";
import Horizontal from "./horizontal";

export default {
    components: {
        Horizontal,
        Vertical
    },
    data() {
        return {
            repository: null
        };
    },
    computed: {
        ...layoutComputed,
    },
    methods: {
        ...layoutMethods,
    },
    mounted() {   
        this.loadLogo(this.$route.params.organisationcode)
    },
    created() {
    }
};
</script>

<template>
<div>
    <vertical v-if="layoutType === 'vertical'" :layout="layoutType">
        <slot />
    </vertical>

    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
        <slot />
    </Horizontal>
</div>
</template>
